// Meta Pixel (Facebook Pixel) utility
// Pixel ID: 26463549809999340

const PIXEL_ID = '26463549809999340'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

/**
 * Initialize Meta Pixel and fire PageView exactly once.
 */
export function initMetaPixelWithPageView() {
  if (initialized) return
  initialized = true

  // Only set up fbq if it doesn't already exist
  if (!window.fbq) {
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args)
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = [] as any[]

    window.fbq = fbq
    window._fbq = fbq

    // Load fbevents.js
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  // Init our pixel and fire PageView exactly once
  window.fbq('init', PIXEL_ID)
  window.fbq('trackSingle', PIXEL_ID, 'PageView')
}

/**
 * Fire AddToCart event. Call on buy-button click.
 */
export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackSingle', PIXEL_ID, 'AddToCart', {
      content_name: 'The $0 Tax Rescue Guide',
      content_type: 'product',
      value: 6.99,
      currency: 'USD',
    })
  }
}
